const STATS = [
  { val: "7+",         label: "Source types",         sub: "structured + legacy CBS",   color: "text-emerald-300", border: "border-emerald-500/30", bg: "bg-emerald-500/10" },
  { val: "Title Code", label: "Primary key",           sub: "canonical reporting ID",    color: "text-cyan-300",    border: "border-cyan-500/30",    bg: "bg-cyan-500/10"    },
  { val: "100%",       label: "Formula protection",    sub: "BB cells never overwritten",color: "text-violet-300",  border: "border-violet-500/30",  bg: "bg-violet-500/10"  },
  { val: "SHA-256",    label: "Source file tracking",  sub: "per-file integrity hash",   color: "text-amber-300",   border: "border-amber-500/30",   bg: "bg-amber-500/10"   },
  { val: "SQLite",     label: "Audit database",        sub: "timestamped event log",     color: "text-sky-300",     border: "border-sky-500/30",     bg: "bg-sky-500/10"     },
  { val: "Monthly",    label: "Reporting cadence",     sub: "previous master → current", color: "text-teal-300",    border: "border-teal-500/30",    bg: "bg-teal-500/10"    },
];

const PIPELINE_STEPS = [
  { label: "Ingest",       sub: "Multi-source",   fill: "rgba(52,211,153,.1)",  stroke: "rgba(52,211,153,.4)"  },
  { label: "Validate",     sub: "Period + TC",    fill: "rgba(34,211,238,.1)",  stroke: "rgba(34,211,238,.4)"  },
  { label: "Route",        sub: "Authority zones",fill: "rgba(56,189,248,.1)",  stroke: "rgba(56,189,248,.4)"  },
  { label: "Insert",       sub: "Value + formula",fill: "rgba(167,139,248,.1)", stroke: "rgba(167,139,248,.4)" },
  { label: "Review",       sub: "Conflict queue", fill: "rgba(251,191,36,.1)",  stroke: "rgba(251,191,36,.4)"  },
  { label: "Archive",      sub: "Run + metadata", fill: "rgba(248,113,113,.1)", stroke: "rgba(248,113,113,.4)" },
];

export default function ProcessingDashboard() {
  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">PROCESSING OVERVIEW</p>
        <h4 className="mt-1 text-sm font-semibold text-white">Regulatory reporting automation pipeline</h4>
        <p className="mt-1 text-xs text-slate-400">
          Transforms fragmented department-level banking inputs into a controlled Bangladesh Bank RIT master workbook through Title Code mapping, source authority routing, formula-aware insertion, human review, and immutable audit logging.
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {STATS.map(({ val, label, sub, color, border, bg }) => (
          <div key={label} className={`rounded-xl border ${border} ${bg} p-3`}>
            <p className={`text-lg font-bold ${color}`}>{val}</p>
            <p className="mt-0.5 text-xs font-medium text-slate-200">{label}</p>
            <p className="text-[10px] text-slate-500">{sub}</p>
          </div>
        ))}
      </div>

      {/* Pipeline SVG */}
      <div className="overflow-x-auto rounded-xl border border-white/10 bg-black/30 p-4">
        <p className="mb-3 font-mono text-[10px] tracking-[0.18em] text-slate-500">PROCESSING PIPELINE</p>
        <svg viewBox="0 0 700 90" width="100%" style={{ minWidth: 520 }}>
          <defs>
            <marker id="rit-arr" viewBox="0 0 10 10" refX={8} refY={5} markerWidth={5} markerHeight={5} orient="auto-start-reverse">
              <path d="M2 1L8 5L2 9" fill="none" stroke="rgba(255,255,255,.2)" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
            </marker>
          </defs>
          {PIPELINE_STEPS.map((s, i) => {
            const x = 10 + i * 116;
            return (
              <g key={s.label}>
                <rect x={x} y={10} width={100} height={52} rx={7} fill={s.fill} stroke={s.stroke} strokeWidth={0.8} />
                <text x={x + 50} y={33} textAnchor="middle" fontSize={10.5} fontWeight={600} fill="#f0f4ff" fontFamily="system-ui">{s.label}</text>
                <text x={x + 50} y={50} textAnchor="middle" fontSize={9} fill="rgba(255,255,255,.4)" fontFamily="system-ui">{s.sub}</text>
                {i < PIPELINE_STEPS.length - 1 && (
                  <line x1={x + 100} y1={36} x2={x + 116} y2={36} stroke="rgba(255,255,255,.15)" strokeWidth={1.2} markerEnd="url(#rit-arr)" />
                )}
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
}
